import { findConnectorTypes } from "./findConnectorTypes";

const SUGGESTION_LIMIT = 10;

// Connector types the request matched in the catalog that the caller has no
// usable connector for. `configuredProducts` must cover every match, not just
// a page of them, or a connector the caller already has comes back as a
// suggestion.
export function suggestConnectorTypes(
  request: { search?: string | null; targetUrl?: string | null },
  configuredProducts: ReadonlySet<string>
) {
  return findConnectorTypes(request)
    .filter((type) => !configuredProducts.has(type.identifier))
    .slice(0, SUGGESTION_LIMIT);
}
